export const WORK_MODEL_TYPES = Object.freeze({
    ON_SITE: {
        label: 'On-Site',
        value: 'On-Site'
    },
    REMOTE: {
        label: 'Remote',
        value: 'Remote'
    },
    HYBRID: {
        label: 'Hybrid',
        value: 'Hybrid'
    }
});

export const JOB_TYPE_MODEL_TYPES = Object.freeze({
    PERMANENT: {
        label: "Permanent",
        value: "permanent",
    },
    PART_TIME: {
        label: "Part-time",
        value: "part-time",
    },
    CONTRACT: {
        label: "Contract",
        value: "contract",
    },
    FREELANCE: {
        label: "Freelance",
        value: "freelance",

    },
    INTERNSHIP: {
        label: "Internship",
        value: "internship",

    },
    TEMPORARY:
        {
            label: "Temporary",
            value: "temporary",

        },
    CONSULTING:
        {
            label: "Consulting",
            value: "consulting",

        },
    COMMISSION_BASED:
        {
            label: "Commission based",
            value: "commission-based",

        }
});

export const JOB_CATEGORY_MODEL_TYPE = Object.freeze({
    SOFTWARE_DEVELOPMENT: {
        label: 'Software Development',
        value: 'software_development',
        description: 'Software Development includes roles such as front-end developer, back-end developer, and full-stack developer, dedicated to building and enhancing software applications.\n'
    },
    WEB_DEVELOPMENT: {
        label: 'Web Development',
        value: 'web_development',
        description: ''
    },
    DATA_SCIENCE: {
        label: "Data Science",
        value: "data_science",
        description: 'Data Science features roles like data analyst, data scientist, and machine learning engineer, aimed at analyzing data to drive business decisions.\n'
    },
    IT_SUPPORT: {
        label: 'IT Support',
        value: 'it_support',
        description: 'IT Support includes roles like help desk technician, IT specialist, and support engineer, centered on troubleshooting and maintaining IT systems.'
    },
    NETWORK_ENGINEERING: {
        label: "Network Engineering",
        value: "network_engineering",
        description: 'Network Engineering offers roles such as network architect, network administrator, and network engineer, focused on designing and managing networks.\n'
    },
    CYBERSECURITY: {
        label: "Cybersecurity",
        value: "cybersecurity",
        description: 'Cybersecurity includes roles like security analyst, penetration tester, and security engineer, dedicated to protecting digital assets from threats.\n'
    },
    MECHANICAL_ENGINEERING: {
        label: 'Mechanical Engineering',
        value: 'mechanical_engineering',
        description: 'Mechanical Engineering features roles like mechanical engineer, project engineer, and CAD designer, focused on designing and improving mechanical systems.\n'
    },
    ELECTRICAL_ENGINEERING: {
        label: "Electrical Engineering",
        value: "electrical_engineering",
        description: 'Electrical Engineering includes roles such as electrical engineer, electronics engineer, and power systems engineer, involved in developing electrical systems.\n'
    },
    CIVIL_ENGINEERING: {
        label: "Civil Engineering",
        value: "civil_engineering",
        description: 'Civil Engineering includes roles like structural engineer, site engineer, and project manager, dedicated to designing and maintaining infrastructure projects.\n'
    },
    CHEMICAL_ENGINEERING: {
        label: "Chemical Engineering",
        value: "chemical_engineering",
        description: 'Chemical engineers design, develop, and optimize processes for chemical manufacturing.'
    },
    AEROSPACE_ENGINEERING: {
        label: 'Aerospace Engineering',
        value: 'aerospace_engineering',
        description: 'Aerospace Engineering includes roles like aerospace engineer, avionics engineer, and test engineer, focused on innovating in aircraft and spacecraft design.\n'
    },
    BIOMEDICAL_ENGINEERING: {
        label: "Biomedical Engineering",
        value: "biomedical_engineering",
        description: 'Biomedical Engineering features roles like biomedical engineer, clinical engineer, and research scientist, aimed at advancing healthcare technology.\n'
    },
    NURSING: {
        label: "Nursing",
        value: "nursing",
        description: 'Nursing includes roles such as registered nurse, nurse practitioner, and clinical nurse, dedicated to providing compassionate patient care.\n'
    },
    PHYSICIAN: {
        label: "Physicians",
        value: "physicians",
        description: 'Physician roles include general practitioner, specialist, and surgeon, focused on diagnosing, treating, and preventing illnesses.\n'
    },
    ALLIED_HEALTH: {
        label: "Allied Health",
        value: "allied_health",
        description: 'Allied Health includes roles like physical therapist, occupational therapist, and radiographer, dedicated to supporting patient care across specialties.\n'
    },
    PHARMACY: {
        label: "Pharmacy",
        value: "pharmacy",
        description: 'Pharmaceuticals features roles such as pharmacist, pharmacologist, and regulatory affairs specialist, focused on drug development and safety.\n'
    },
    MEDICAL_RESEARCH: {
        label: "Medical Research",
        value: "medical_research",
        description: 'Medical Research includes roles like clinical researcher, biostatistician, and lab technician, aimed at driving medical discoveries and advancements.\n'
    },HEALTHCARE_ADMINISTRATION: {
        label: "Healthcare Administration",
        value: "healthcare_administration",
        description: 'Healthcare Administration includes roles like healthcare manager, hospital administrator, and medical office manager, focused on overseeing healthcare operations.\n'
    },
    ACCOUNTING: {
        label: "Accounting",
        value: "accounting",
        description: 'Accounting offers roles such as accountant, auditor, and financial analyst, centered on ensuring financial accuracy and compliance.\n'
    },
    FINANCE: {
        label: "Finance",
        value: "finance",
        description: 'Finance includes roles like financial advisor, investment banker, and portfolio manager, focused on managing financial planning and growth.\n'
    },
    INVESTMENT_BANKING: {
        label: "Investment Banking",
        value: "investment_banking",
        description: ''
    },
    FINANCIAL_ANALYSIS: {
        label: "Financial Analysis",
        value: "financial_analysis",
        description: ''
    },
    AUDITING: {
        label: "Auditing",
        value: "auditing",
        description: ''
    },
    TAXATION: {
        label: "Taxation",
        value: "taxation",
        description: ''
    }
});

export const YES_NO_TYPE = Object.freeze({
    YES: {
        label: 'Yes',
        value: 'yes'
    },
    NO: {
        label: 'No',
        value: 'no'
    }
});

export const ENABLE_DISABLE_TYPE = Object.freeze({
    ENABLED: {
        label: 'Enable',
        value: 'enable'
    },
    DISABLED: {
        label: 'Disable',
        value: 'disable'
    }
});

export const INDUSTRY_TYPE = Object.freeze({
    AGRICULTURE_FORESTRY: {
        label: 'Agriculture',
        value: 'agriculture'
    },
    MINING: {
        label: 'Mining',
        value: 'mining'
    },
    MANUFACTURING: {
        label: "Manufacturing",
        value: "manufacturing"
    },
    CONSTRUCTION: {
        label: 'Construction',
        value: 'construction'
    },
    RETAIL_WHOLESALE: {
        label: "Retail and Wholesale",
        value: "retail_wholesale"
    },
    TRANSPORTATION_LOGISTICS: {
        label: "Transportation and Logistics",
        value: "transportation_logistics"
    },
    FINANCE_INSURANCE: {
        label: 'Finance and Insurance',
        value: 'finance_insurance'
    },
    REAL_ESTATE: {
        label: "Real Estate",
        value: "real_estate"
    },
    INFORMATION_TECHNOLOGY: {
        label: "Information Technology",
        value: "information_technology"
    },
    HEALTHCARE: {
        label: "Healthcare",
        value: "healthcare"
    },
    EDUCATION: {
        label: 'Education',
        value: 'education'
    },
    TOURISM_HOSPITALITY: {
        label: "Tourism and Hospitality",
        value: "tourism_hospitality"
    },
    MEDIA_COMMUNICATIONS: {
        label: "Media and Communications",
        value: "media_communications"
    },
    LEGAL_SERVICES: {
        label: "Legal Services",
        value: "legal_services"
    },
    PUBLIC_SECTOR: {
        label: "Public Sector",
        value: "public_sector"
    },
    PROFESSIONAL_SERVICES: {
        label: "Professional Services",
        value: "professional_services"
    }
});

export const JOB_FUNCTION_OPTIONS = Object.freeze({
    ACCOUNTING_FINANCE: {
        label: 'Accounting/Finance',
        value: 'accounting_finance'
    },
    ADMINISTRATION: {
        label: 'Administration',
        value: 'administration'
    },
    CUSTOMER_SERVICE: {
        label: 'Customer Service',
        value: 'customer_service'
    },
    LEARNING_DEVELOPMENT: {
        label: 'Learning and Development',
        value: 'learning_development'
    },
    ENGINEERING: {
        label: 'Engineering',
        value: 'engineering'
    },
    HUMAN_RESOURCES: {
        label: 'Human Resources',
        value: 'human_resources'
    }
});

export const SALARY_BAND_TYPE = Object.freeze({
    BAND_ONE: {
        label: '<R200 000 per annum',
        value: 'band_one'
    },
    BAND_TWO: {
        label: 'R200 000 – R350 000',
        value: 'band_two'
    },
    BAND_THREE: {
        label: 'R350 000 – R500 000',
        value: 'band_three'
    },
    BAND_FOUR: {
        label: 'R500 000 – R650 000',
        value: 'band_four'
    },
    BAND_FIVE: {
        label: 'R650 000 – R800 000',
        value: 'band_five'
    },
    BAND_SIX: {
        label: '>R800 000',
        value: 'band_six'
    }
});

export const BONUS_TYPE = Object.freeze({
    PERFORMANCE: {
        label: 'Performance',
        value: 'performance'
    },
    COMMISSION: {
        label: 'Commission',
        value: 'commission'
    },
    PROFIT_SHARE: {
        label: 'Profit Share',
        value: 'Profit Share'
    },
    ADHOC: {
        label: 'Adhoc',
        value: 'adhoc'
    },
    NONE: {
        label: 'None',
        value: 'none'
    },
    OTHER: {
        label: 'Other',
        value: 'other'
    }
});

export const LEAVE_TYPE = Object.freeze({
    OPTION_ONE: {
        label: '18 days',
        value: '18'
    },
    OPTION_TWO: {
        label: '21 days',
        value: '21'
    }
});